@if (dataContext) {
  <form class="astral-dialog-form astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()">
    <h2>{{ 'RENTAL_OBJECT.BROKER_INFORMATION' | translate }}</h2>
    <section class="astral-section-surface astral-form-stack">
      <astral-input
        [label]="'RENTAL_OBJECT_FORM.RENTAL_OBJECT_NUMBER_LABEL'"
        [value]="dataContext.rentalId"
        [readonly]="true"
      ></astral-input>
      <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
        <astral-select [control]="form.controls['typeOfCalculationDate']" [itemsSource]="typeOfDateSelection"></astral-select>
        <astral-date-picker [control]="form.controls['calculationDate']"></astral-date-picker>
      </astral-layout-group>
    </section>
    <div class="astral-form-actions astral-form-actions--start">
      <astral-button variant="primary" type="submit" [label]="'OK'"></astral-button>
      <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
    </div>
  </form>
}
